module.exports = __webpack_public_path__ + "static/media/blury_artist2.16c2b48a.jpg";